import React, { useState } from "react";
import {
  Box,
  Typography,
  Stack,
  Divider,
  Chip,
  Paper,
  Pagination,
} from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import MaterialTypography from "../../../components/MaterialTypography";

const ITEMS_PER_PAGE = 2; // You can tweak this

const FollowUpTaskList = ({ tasks, height }) => {
  const [page, setPage] = useState(1);

  const pageCount = Math.ceil(tasks.length / ITEMS_PER_PAGE);
  const paginatedTasks = tasks.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  const handleChange = (_, value) => {
    setPage(value);
  };

  return (
    <Paper sx={{ p: 2, borderRadius: 2, height: height, display: "flex", flexDirection: "column", boxShadow:"0px 0px 10px 0px #0000001A" }}>
      <Typography variant="h6" fontWeight="bold" mb={2}>
        Overdue Tasks
      </Typography>

      {tasks.length === 0 ? (
        <Typography color="textSecondary">No pending tasks.</Typography>
      ) : (
        <>
          <Stack spacing={2} sx={{ overflowY: "auto", flexGrow: 1 }}>
            {paginatedTasks.map((task) => (
              <Box key={task.taskId}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <AssignmentIcon color="primary" />
                  <Typography variant="subtitle1" fontWeight="medium">
                    {task.title}
                  </Typography>
                </Stack>

                <MaterialTypography variant="body2" ml={4}>
                  Assigned to:
                  <MaterialTypography variant="h6" fontWeight="bold" display="inline">
                    {task.assignedTo}
                  </MaterialTypography>
                  <Chip
                    sx={{ ml: 10 }}
                    label={task.status.replace("_", " ").toUpperCase()}
                    size="small"
                    color={
                      task.status.toLowerCase().includes("overdue") ? "error" : "warning"
                    }
                  />
                </MaterialTypography>

                <MaterialTypography variant="body2" ml={4}>
                  Deadline:{" "}
                  <MaterialTypography variant="h6" fontWeight="bold" display="inline">
                    {new Date(task.deadlineDate).toLocaleDateString()}
                  </MaterialTypography>
                </MaterialTypography>

                <Divider />
              </Box>
            ))}
          </Stack>

          <Box mt={2} display="flex" justifyContent="center">
            <Pagination
              count={pageCount}
              page={page}
              onChange={handleChange}
              size="small"
              color="primary"
            />
          </Box>
        </>
      )}
    </Paper>
  );
};

export default FollowUpTaskList;
